const FacebookLogo = ({ color = "#000", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 48 48"
    {...props} // Spread the remaining props
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M26.28 46V25.93h6.49l.97-7.82h-7.46v-5c0-2.26.6-3.8 3.73-3.8H34v-7c-.69-.1-3.06-.31-5.81-.31-5.75 0-9.69 3.65-9.69 10.34v5.77H12v7.82h6.5V46h7.78Z"
      clipRule="evenodd"
    />
  </svg>
);

export default FacebookLogo;
